export const HEAP_IO_APP_ID = {
    qa: {
        heapAppId: '4274715838'
    },
    stg: {
        heapAppId: '1164359906'
    },
    uat: {
        heapAppId: '3854896323'
    },
    prod: {
        heapAppId: '2601381962'
    }
};

/**
 * Get app id by env.
 * @param environment - the env name.
 */
export function getHeapIoAppIdByEnv(environment) {
    const { heapAppId } = HEAP_IO_APP_ID[environment]
        ? HEAP_IO_APP_ID[environment]
        : HEAP_IO_APP_ID.prod;
    return heapAppId;
}
